export const DELETE_DOC_MEMBERSHIP_MODAL_NAME =
  'DELETE_DOC_MEMBERSHIP_MODAL_NAME';
